import { ArrowRight, CheckCircle2 } from "lucide-react";
import type { RunSummary as RunSummaryData } from "../lib/runSummary";

export function RunSummary({
  summary,
  onContinue,
  onClose,
}: {
  summary: RunSummaryData;
  onContinue: () => void;
  onClose: () => void;
}) {
  const correctPct = summary.answered ? Math.round((summary.correct / summary.answered) * 100) : 0;

  return (
    <section className="run-summary" aria-label="Run-Zusammenfassung">
      <span className="reward-tick" aria-hidden="true" />
      <div className="panel-heading">
        <span className="eyebrow">Run abgeschlossen</span>
        <h2>{summary.pathLabel}: Was jetzt sicherer sitzt.</h2>
      </div>
      <div className="summary-grid">
        <div className="metric-card">
          <span>Antworten</span>
          <strong>{summary.answered}</strong>
          <small>{correctPct}% korrekt</small>
        </div>
        <div className="metric-card">
          <span>Neu stabil</span>
          <strong>{summary.newlyStable.length} Konzepte</strong>
          <small>pruefungsstabil erreicht</small>
        </div>
        <div className="metric-card">
          <span>Meisterung</span>
          <strong>{summary.masteryDeltaPct >= 0 ? "+" : ""}{summary.masteryDeltaPct}%</strong>
          <small>Fortschritt in diesem Run</small>
        </div>
      </div>
      <p className="summary-note">
        <CheckCircle2 size={17} />
        Kurz speichern, dann entweder direkt den naechsten Run starten oder bewusst pausieren.
      </p>
      <div className="question-actions">
        <button className="primary-action" onClick={onContinue} type="button">
          Naechster Run
          <ArrowRight size={18} />
        </button>
        <button className="ghost-action" onClick={onClose} type="button">
          Pause
        </button>
      </div>
    </section>
  );
}
